module.exports = __webpack_public_path__ + "img/img44.a206faaa.png";